import { ValueObject, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class ImportProcedureLookup extends ValueObject {
    public importProcedureId: number = 0;

    public storedProcedure: string = "";

    public normaliseInd: boolean = false;

    public extractionInd: boolean = false;

    public dataInterceptionInd: boolean = false;

    public priority: number = 0;
}